var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.85942 0 3.84865 0.82166 2.33513 2.33514C0.821506 3.84861 0 5.85934 0 8C0 10.1407 0.82166 12.1514 2.33513 13.6649C3.84861 15.1784 5.8595 16 8 16C10.1406 16 12.1514 15.1783 13.6649 13.6649C15.1784 12.1514 16 10.1405 16 8C16 5.85942 15.1783 3.84865 13.6649 2.33514C12.1514 0.821506 10.1407 0 8 0ZM13.0378 13.0378C11.6973 14.4 9.90274 15.1351 8 15.1351C6.09726 15.1351 4.30263 14.4 2.96216 13.0378C1.6217 11.6756 0.864865 9.90274 0.864865 8C0.864865 6.09726 1.59996 4.30263 2.96216 2.96216C4.32436 1.6217 6.09726 0.864865 8 0.864865C9.90274 0.864865 11.6974 1.59996 13.0378 2.96216C14.3783 4.32436 15.1351 6.09726 15.1351 8C15.1351 9.90274 14.4 11.6974 13.0378 13.0378Z",
    fill: "#7AD81B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77715 12.0542V11.2206C9.76506 11.1175 10.7334 10.4985 10.7334 9.3159C10.7334 7.72161 9.24325 7.53777 8.15492 7.40339C7.44112 7.31861 6.89526 7.2182 6.89526 6.77376C6.89526 6.16153 7.74504 6.09552 8.11016 6.09552C8.64913 6.09552 9.22545 6.35046 9.42214 6.67574L9.46688 6.75017L10.5279 6.25944L10.4841 6.17016C10.0731 5.33034 9.3315 5.09414 8.77708 4.99922V4.26666H7.53442V4.99672C6.33317 5.16746 5.61936 5.82754 5.61936 6.77384C5.61936 8.30817 7.01946 8.46465 8.04138 8.57912C8.97362 8.68911 9.40806 8.92353 9.40806 9.31598C9.40806 10.0605 8.3897 10.1185 8.07733 10.1185C7.38619 10.1185 6.71845 9.77155 6.52446 9.31128L6.48675 9.22141L5.33301 9.71038L5.3713 9.80005C5.72469 10.6274 6.49088 11.1439 7.53425 11.2611V12.0546L8.77712 12.0544L8.77715 12.0542Z",
    fill: "#7AD81B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.bc1ac1cdbb7d58b0838e5192a74fbca1.svg";
export { ForwardRef as ReactComponent };